@use 'styles/utils/variables' as *;
@use 'styles/utils/mixins' as *;

.navMenu {
  justify-content: center;
  // antd paints the menu on the plain surface, which is darker than the drawer it sits in (dark theme).
  background: transparent !important;
  border: transparent !important;
  // The drawer's full width: a fixed 150px / 180px clipped "Site Reporting" to "Site Repo…" (Inter
  // at the 16px desktop size, with the icon in front).
  width: 100% !important;
}

.navMenuItem {
  font-size: var(--fontSize-base);
  padding: 0 0.9rem !important;

  @include mq(lg) {
    font-size: 1.6rem;
  }

  & span[class$='ant-menu-title-content'] a {
    color: $text-color-primary !important;
  }

  &:hover span[class$='ant-menu-title-content'] a {
    color: $text-color-selected !important;
  }

  &[class*='ant-menu-item-selected'] {
    & span[class$='ant-menu-title-content'] a {
      color: $text-color-selected !important;
    }
  }

  &::after {
    right: 0.9rem !important;
    left: 0.9rem !important;
  }
}

.navMenuItem:hover svg {
  color: $text-color-selected !important;
}

// Current section: primary glyph and label on the soft primary tint, like the active tab pill in
// the mobile app. Plain primary is 2.8:1 on that tint in light; the on-tint text colour clears 4.5:1.
.navMenuItemActive {
  &[class*='ant-menu-item'],
  & > [class*='ant-menu-submenu-title'] {
    border-radius: $radius-md;
    background: $tint-primary !important;
  }

  & svg,
  & [class*='ant-menu-title-content'],
  & [class*='ant-menu-title-content'] a {
    color: $text-on-tint-primary !important;
  }
}
